<template>
  <button
    class="inspiration-card m-25"
    :class="{selected: isSelected}"
    :aria-selected="isSelected"
    @click="handleInspirationClicked"
  >
    <pdl-card :qaid="`inspiration-card-${inspiration.pk}`" class="inspiration-details mt-1">
      <template #image>
        <img
          v-if="inspiration.p1ImageUrl"
          :src="inspiration.p1ImageUrl"
          :alt="`${bikeData.modelName} - ${inspiration.p1PresetName}`"
          :qaid="`inspiration-image-${inspiration.pk}`"
        />
      </template>
      <template #bodyContent>
        <p qaid="inspiration-card-name" class="font-medium text-xs leading-tight mx-1 text-center">
          {{ inspiration.p1PresetName }}
        </p>
        <p qaid="inspiration-card-price" class="font-normal text-xs leading-tight mx-1 text-center">
          {{ inspiration.advertisedPrice }}
        </p>
      </template>
    </pdl-card>
  </button>
</template>

<script>
import {PdlCard} from '@pedal/pdl-card';
import {mapGetters, mapState} from 'vuex';
import {GROUP_IDS} from '@/familyDetailsPage/store/bike-customization';

export default {
  name: 'InspirationCard',
  components: {
    PdlCard,
  },
  props: {
    inspiration: {
      type: Object,
      required: true,
    },
  },
  emits: ['inspiration-clicked'],
  computed: {
    ...mapState('bikeCustomization', ['bikeData']),
    ...mapGetters('bikeCustomization', ['selections']),

    isSelected() {
      return (
        this.inspiration.p1PresetThemeChoiceId ===
        this.selections?.find((data) => data.groupId === GROUP_IDS.THEME)?.choiceId
      );
    },
  },
  methods: {
    handleInspirationClicked() {
      if (this.isSelected) return;
      this.$emit('inspiration-clicked', this.inspiration);
    },
  },
};
</script>

<style lang="scss" scoped>
.inspiration-card {
  transition: scale 0.1s ease-in, box-shadow 0.2s ease-in, border-color 0.2s ease, background-color 0.2s ease;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0);
  scale: 1;
  border: 0.125rem solid transparent;

  &.selected {
    border-color: var(--blue-100, #007ab8);
    box-shadow: 0 7px 6px -6px rgba(0, 0, 0, 0.25), 0 14px 15px -13px rgba(0, 0, 0, 0.3);
  }

  .inspiration-details {
    transition: background-color 0.2s ease, border-color 0.2s ease;
  }

  @media (hover: hover) {
    &:hover {
      background-color: var(--blue-10, #e6f2f8);
      border-color: var(--blue-100, #007ab8);

      .inspiration-details {
        background-color: var(--blue-10, #e6f2f8);
        border-color: var(--blue-100, #007ab8);
      }
    }
  }

  &:active {
    scale: 0.99;
  }

  &:focus-visible {
    outline: 2px solid var(--blue-100);
    outline-offset: 2px;
  }
}

:deep(.pdl-card__body) {
  padding: 0;
}
</style>
